const finalVisibleGapTranslations = {
  ru: {
    'ROMIND KIDS profile': 'Профиль ROMIND KIDS',
    'ROMIND KIDS Story Portal': 'Портал Stories ROMIND KIDS',
  },
  es: {
    'ROMIND KIDS profile': 'Perfil de ROMIND KIDS',
    'ROMIND KIDS Story Portal': 'Portal de Stories de ROMIND KIDS',
  },
  fr: {
    'ROMIND KIDS profile': 'Profil ROMIND KIDS',
    'ROMIND KIDS Story Portal': 'Portail Stories de ROMIND KIDS',
  },
  ko: {
    'ROMIND KIDS profile': 'ROMIND KIDS 프로필',
    'ROMIND KIDS Story Portal': 'ROMIND KIDS Story 포털',
  },
  ar: {
    'ROMIND KIDS profile': 'ملف ROMIND KIDS الشخصي',
    'ROMIND KIDS Story Portal': 'بوابة Stories في ROMIND KIDS',
  },
};

export default finalVisibleGapTranslations;
